export default __webpack_public_path__ + "static/B0279-7a3d95765b1bed6e773af01acf3e6599.png";